module.exports = __webpack_public_path__ + "img/09d.78b77aaa.png";